/* KRYSTO · Panier mobile (glisser vers le bas pour fermer) + barre d'achat sur ordinateur */
(function () {
  if (window.kxExtras) return;
  window.kxExtras = true;

  function init() {
    // Panier : on tire la poignée vers le bas pour fermer (téléphone)
    var cart = document.getElementById('kx-cart');
    if (cart && !cart.dataset.kxDrag) {
      cart.dataset.kxDrag = '1';
      var y0 = null, dy = 0;
      cart.addEventListener('touchstart', function (e) {
        if (!e.target.closest('.kx-cart__top')) return;
        y0 = e.touches[0].clientY; dy = 0;
        cart.classList.add('is-drag');
      }, { passive: true });
      cart.addEventListener('touchmove', function (e) {
        if (y0 === null) return;
        dy = Math.max(0, e.touches[0].clientY - y0);
        cart.style.setProperty('--kx-drag', dy + 'px');
      }, { passive: true });
      cart.addEventListener('touchend', function () {
        if (y0 === null) return;
        y0 = null;
        cart.classList.remove('is-drag');
        cart.style.removeProperty('--kx-drag');
        if (dy > 90 && window.kxCart) window.kxCart.close();
      });
    }

    // Fiche produit : la barre apparaît quand le bouton « Ajouter au panier » sort de l'écran
    var add = document.querySelector('.kx-pdp__add');
    var bar = document.querySelector('.kx-pdp__sticky');
    if (add && bar && 'IntersectionObserver' in window && !bar.dataset.kxObs) {
      bar.dataset.kxObs = '1';
      new IntersectionObserver(function (en) {
        var e = en[0];
        bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(add);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* KRYSTO · Cartes cliquables en entier : un clic n'importe où sur la carte ouvre le lien de son bouton */
(function () {
  if (window.kxCards) return;
  window.kxCards = true;
  // Cartes concernées : saveurs, offres, boutique
  var CARTES = '.kx-saveur, .kx-offre, .kx-shop__card';

  function marquer() {
    document.querySelectorAll(CARTES).forEach(function (c) {
      var a = c.querySelector('a[href]:not([href="#"])');
      if (a) c.classList.add('kx-card-link');
    });
  }

  document.addEventListener('click', function (e) {
    var carte = e.target.closest(CARTES);
    if (!carte) return;
    // Les boutons, liens, champs et formulaires gardent leur propre action
    if (e.target.closest('a, button, input, select, textarea, label, form, video')) return;
    var a = carte.querySelector('a[href]:not([href="#"])');
    if (!a) return;
    if (e.metaKey || e.ctrlKey) window.open(a.href, '_blank'); else window.location.href = a.href;
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', marquer); else marquer();
  document.addEventListener('shopify:section:load', marquer);
})();

/* KRYSTO · Apparition des blocs au défilement */
(function () {
  if (window.kxAnim) return;
  window.kxAnim = true;
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var mobile = window.matchMedia('(max-width: 749px)');

  // Ce qui apparaît en glissant (titres, cartes)
  var SEL = '.kx-h2, .kx-head__text, .kx-saveur, .kx-offre, .kx-preuve, .kx-moment, .kx-objectif, .kx-shop__card, .kx-shop__club, .kx-club__card, .kx-club__steps li, .kx-pdv__card, .kx-pdv__map, .kx-faq details, .kx-avis__card, .kx-histoire__block, .kx-comparatif table';

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      var el = en.target;
      el.classList.add('is-in');
      io.unobserve(el);
      // Une fois apparu, on rend la main aux effets de survol
      setTimeout(function () { el.classList.remove('kx-reveal', 'is-in'); el.style.removeProperty('--kx-d'); }, 1300);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  function prep() {
    document.querySelectorAll(SEL).forEach(function (el) {
      if (el.classList.contains('kx-reveal') || el.closest('.kx-cart, .kx-drawer, .kx-dd__panel')) return;
      // Sur téléphone, les cartes des carrousels qui glissent restent fixes (sinon elles montent en glissant)
      if (mobile.matches && el.closest('.kx-swipe, .kx-swipe-m')) return;
      // Décalage pour les cartes d'une même rangée
      var i = Array.prototype.indexOf.call(el.parentNode.children, el);
      el.style.setProperty('--kx-d', Math.min(i, 4) * 0.08 + 's');
      el.classList.add('kx-reveal');
      io.observe(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prep); else prep();
  // Dans l'éditeur de thème, les sections se rechargent
  document.addEventListener('shopify:section:load', prep);
})();
